import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthGuard } from 'components/AuthGuard';
import OpsToolLayout from './layouts/OpsToolLayout';
import BillOpsPage from 'pages/central/settlement/BillOpsPage';
import BcpCheckJobListPage from 'pages/central/settlement/bcp/BcpCheckJobListPage';
import BcpCheckJobFormPage from 'pages/central/settlement/bcp/BcpCheckJobFormPage';
import BcpCheckJobDetailPage from 'pages/central/settlement/bcp/BcpCheckJobDetailPage';
import BcpCheckJobVersionsPage from 'pages/central/settlement/bcp/BcpCheckJobVersionsPage';
import BcpCheckUserGroupListPage from 'pages/central/settlement/bcp/BcpCheckUserGroupListPage';
import BcpCheckResultListPage from 'pages/central/settlement/bcp/BcpCheckResultListPage';
import BcpCheckResultDetailPage from 'pages/central/settlement/bcp/BcpCheckResultDetailPage';
import FeeItemFactorConfigPage from 'pages/central/pricing/FeeItemFactorConfigPage';
import WorkflowTemplateDesignerPage from 'pages/central/settlement/WorkflowTemplateDesignerPage';
import SettlementDataMaintenancePage from './settlement/SettlementDataMaintenancePage';
import TmpRunTaskRerunPage from './settlement/TmpRunTaskRerunPage';
import SettlementAuditLogPage from './settlement/SettlementAuditLogPage';
import DspDriverBillPage from './settlement/DspDriverBillPage';
import DspBillingCadenceWhitelistPage from './settlement/DspBillingCadenceWhitelistPage';
import TableSplitCompensationPage from './settlement/TableSplitCompensationPage';
import PickupHubDataFixPage from './pickup/PickupHubDataFixPage';
import ForceMergeStationPage from './pickup/ForceMergeStationPage';
import MarkStationsUnreachablePage from './pickup/MarkStationsUnreachablePage';
import SorterApiToolPage from './wms/SorterApiToolPage';
import OrderWmsColumnFixPage from './wms/OrderWmsColumnFixPage';
import TtSortingConfigPage from './wms/TtSortingConfigPage';
import DataRetentionPage from './wms/data-retention/DataRetentionPage';
import ExternalStationPage from './tms/external-station/ExternalStationPage';
import DispatchToolPage from './tms/dispatch-tool/DispatchToolPage';
import I18nConfigAdminPage from './tms/i18n-config/I18nConfigAdminPage';
import TaskManagementPage from './tms/task-management/TaskManagementPage';

const OpsToolRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<AuthGuard><OpsToolLayout /></AuthGuard>}>
                <Route path="settlement/bill-ops" element={<BillOpsPage />} />
                <Route path="settlement/bcp/check-jobs" element={<BcpCheckJobListPage />} />
                <Route path="settlement/bcp/check-jobs/create" element={<BcpCheckJobFormPage />} />
                <Route path="settlement/bcp/check-jobs/:id" element={<BcpCheckJobDetailPage />} />
                <Route path="settlement/bcp/check-jobs/:id/edit" element={<BcpCheckJobFormPage />} />
                <Route path="settlement/bcp/check-jobs/:id/versions" element={<BcpCheckJobVersionsPage />} />
                <Route path="settlement/bcp/job-versions" element={<BcpCheckJobVersionsPage />} />
                <Route path="settlement/bcp/user-groups" element={<BcpCheckUserGroupListPage />} />
                <Route path="settlement/bcp/check-results" element={<BcpCheckResultListPage />} />
                <Route path="settlement/bcp/check-results/:id" element={<BcpCheckResultDetailPage />} />
                <Route path="settlement/price-center/fee-item-factor-config" element={<FeeItemFactorConfigPage />} />
                <Route path="settlement/workflow-template-designer" element={<WorkflowTemplateDesignerPage />} />
                <Route path="settlement/data-maintenance" element={<SettlementDataMaintenancePage />} />
                <Route path="settlement/tmp-run-task-rerun" element={<TmpRunTaskRerunPage />} />
                <Route path="settlement/audit-log" element={<SettlementAuditLogPage />} />
                <Route path="settlement/table-split-compensation" element={<TableSplitCompensationPage />} />
                <Route path="settlement/dsp-driver-bill" element={<DspDriverBillPage />} />
                <Route path="settlement/dsp-billing-cadence-whitelist" element={<DspBillingCadenceWhitelistPage />} />
                <Route path="pickup/force-merge" element={<ForceMergeStationPage />} />
                <Route path="pickup/mark-unreachable" element={<MarkStationsUnreachablePage />} />
                <Route path="wms/pickup-hub-data-fix" element={<PickupHubDataFixPage />} />
                <Route path="wms/sorter-api-tool" element={<SorterApiToolPage />} />
                <Route path="wms/order-wms-column-fix" element={<OrderWmsColumnFixPage />} />
                <Route path="wms/tt-location-config" element={<TtSortingConfigPage />} />
                <Route path="wms/data-retention" element={<DataRetentionPage />} />
                <Route path="tms/external-station" element={<ExternalStationPage />} />
                <Route path="tms/dispatch-tool" element={<DispatchToolPage />} />
                <Route path="tms/task-management" element={<TaskManagementPage />} />
                <Route path="tms/i18n-config" element={<I18nConfigAdminPage />} />
            </Route>
        </Routes>
    );
};

export default OpsToolRoutes;
